import script from "./PaymentLinkPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentLinkPage.vue?vue&type=script&setup=true&lang=js"

import "./PaymentLinkPage.vue?vue&type=style&index=0&id=6f5d1fa8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f5d1fa8"]])

export default __exports__